import { v4 as uuidv4 } from 'uuid';
import { ConnectionSettingsMarketingEventsView } from '../view/ConnectionSettingsMarketingEventsView';

export const ConnectionSettingsMarketingEventsTab = (): ITab => {

    return {
        id: uuidv4(),
        title: 'Настройка обмена маркетинга',
        view: {
            content: <ConnectionSettingsMarketingEventsView />
        }
    }
}